import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import { addLeave, getLeavePolicy } from '../../../redux/MainAction';
import moment from 'moment';

const AddLeaveModel = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const policy = useSelector((state) => state?.Webtracker?.leavePolicy);
  const tmlist = useSelector((state) => state.Webtracker.member);

  const [addData, setAddData] = useState({
    leavePolicyId: '', // required
    employeeId: '', // optional
    startDate: '', // required
    endDate: '', // required
    leaveDurationType: 'FULL-DAY', // optional, pass if leave policy is DAYS, values can be 'FULL-DAY', 'FIRST-HALF', 'SECOND-HALF'
    reason: '', // optiona, if leave policy requires reason then it is required
  });

  const onHandleAddData = (e) => {
    const { name, value } = e.target;
    setAddData({ ...addData, [name]: value });
  };

  useEffect(() => {
    if (!policy || !Array.isArray(policy?.rows)) getList();
  }, [policy]);

  const getList = () => {
    var data = {
      offset: 0,
      limit: 100,
    };
    dispatch(getLeavePolicy(data));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    var payload = {
      leavePolicyId: addData?.leavePolicyId, // required
      employeeId: addData?.employeeId, // required
      startDate: moment(addData?.startDate).format('YYYY-MM-DD'), // required
      endDate: moment(addData?.endDate).format('YYYY-MM-DD'), // required
      leaveDurationType: addData?.leaveDurationType, // optional, pass if leave policy is DAYS, values can be 'FULL-DAY', 'FIRST-HALF', 'SECOND-HALF'
      reason: addData?.reason, // optiona, if leave policy requires reason then it is required
    };
    console.log('policy', payload);
    dispatch(addLeave(payload));
    onClose();
    setAddData({
      leavePolicyId: '',
      startDate: '',
      endDate: '',
      leaveDurationType: 'FULL-DAY',
      reason: '',
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal1 leave_modal' }}
    >
      <div className="d-flex justify-content-between align-items-center pb-2">
        <h6>Add Leave</h6>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="tab-content pr-2">
        <div className="form-group ">
          <label for="username1" className="font-14 text-muted ">
            Member<span className="text-danger">*</span>
          </label>
          <div className="">
            <select
              className="form-control"
              name="employeeId"
              value={addData?.employeeId}
              onChange={onHandleAddData}
            >
              <option>-select member-</option>
              {tmlist?.rows?.map((plc, idx) => (
                <option value={plc?.id}>
                  {plc?.firstName} {plc?.lastName}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-group ">
          <label for="username1" className="font-14 text-muted ">
            Leave Policy <span className="text-danger">*</span>
          </label>
          <div className="">
            <select
              className="form-control"
              name="leavePolicyId"
              value={addData?.leavePolicyId}
              onChange={onHandleAddData}
            >
              <option>-select policy-</option>
              {policy?.rows?.map((plc, idx) => (
                <option value={plc?.id}>{plc?.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="d-flex " style={{ gap: '5px', width: '100%' }}>
          <div className="form-group " style={{ width: '100%' }}>
            <label htmlFor="username4" className="font-14 text-muted ">
              Start <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              id="username4"
              name="startDate"
              value={addData?.startDate}
              onChange={onHandleAddData}
            />
          </div>
          <div className="form-group  " style={{ width: '100%' }}>
            <label htmlFor="username5" className="font-14 text-muted ">
              End <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              id="username5"
              name="endDate"
              value={addData?.endDate}
              onChange={onHandleAddData}
            />
          </div>
        </div>

        <div className="form-group ">
          <label htmlFor="username7" className="font-14 text-muted ">
            Leave Duration
          </label>
          <div className="">
            <select
              className="form-control"
              name="leaveDurationType"
              value={addData?.leaveDurationType}
              onChange={onHandleAddData}
            >
              <option value="FULL-DAY">Full Day</option>
              <option value="FIRST-HALF">1st Half</option>
              <option value="SECOND-HALF">2nd Half</option>
            </select>
          </div>
        </div>

        <textarea
          type="text"
          className="form-control mt-2"
          rows={2}
          placeholder="Reason"
          name="reason"
          value={addData?.reason}
          onChange={onHandleAddData}
        />
      </div>

      <div className="modal-footer mt-2">
        <button type="button" className="btn btn-light" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn-dark" onClick={onSubmit}>
          Add Leave
        </button>
      </div>
    </Modal>
  );
};

export default AddLeaveModel;
